import { ToppingItem } from './components';

import { useToppingsByParentId } from './hooks';

import makeClasses from './ToppingsByParentId.style';

import type { ToppingToPrint } from 'features/print-management/order-invoice-printing';

export function ToppingsByParentId(props: Props) {
  const { localeLang, toppings } = props;

  const { toppingsSorted } = useToppingsByParentId({ toppings });

  const _classes = makeClasses();

  return (
    <>
      {toppingsSorted.length > 0 && (
        <ul
          data-toppings-level={0}
          aria-label='topping-list'
          className={_classes.toppingList}
        >
          {toppingsSorted.map((topping, idx) => (
            <ToppingItem
              nextLevel={1}
              topping={topping}
              localeLang={localeLang}
              key={`${topping.id}-${idx}`}
              previousName={toppingsSorted[idx - 1]?.name ?? ''}
            />
          ))}
        </ul>
      )}
    </>
  );
}

interface Props {
  localeLang: string;
  toppings: ToppingToPrint[];
}
